<template>
  <div v-if="league && team" class="row">
    <div class="col-12">
      <article class="fc-m-container ">
        <h2>Team Settings</h2>
        <div class="row p-0">
          <div class="col-12 col-md-8 col-lg-6">
            <form @submit="saveTeam">
              <div class="form-group">
                <label for="name">Team Name:</label>
                <input
                  required
                  class="form-control"
                  type="text"
                  name="name"
                  v-model="name"
                  value=""
                />
              </div>
              <div
                v-if="
                  availableOwners.length &&
                    $store.state.auth.account_type != 'individual'
                "
                class="form-group"
              >
                <label for="owners">Change Owner(s):</label>
                <select
                  v-model="selectedOwners"
                  multiple
                  class="form-control"
                  id="owners"
                  name="owners"
                >
                  <option
                    v-for="player in availableOwners"
                    :key="player.id"
                    :value="player.id"
                    >{{ player.username }}</option
                  >
                </select>
                <p class="small d-none d-md-inline-block">
                  Hold <code>Ctrl</code> while clicking to make multiple
                  selections.
                </p>
              </div>
              <button type="submit" class="btn btn-primary">Submit</button>
            </form>
          </div>
        </div>
      </article>
    </div>
    <div class="col-12">
      <article class="alert alert-danger">
        <h2>Delete Team</h2>
        <p class="">
          All data associated with this team will be removed. You can not undo
          this action.
        </p>
        <button
          @click="deleteTeam()"
          class="btn btn-danger"
          type="button"
          name="button"
        >
          Delete Team
        </button>
      </article>
    </div>
  </div>
  <loader v-else v-bind:embeded="false"></loader>
</template>

<script>
import { getCookie } from "@/utils/cookies.js";
import Loader from "@/views/components/Loader";

export default {
  name: "TeamsEdit",
  components: {
    loader: Loader
  },
  data: function() {
    return {
      league: null,
      team: null,
      name: "",
      selectedOwners: [],
      availableOwners: []
    };
  },
  created: function() {
    this.getLeague();
  },
  methods: {
    getPotentialOwners: function(league, team) {
      //everyone who is in the league and doesn't have a team, except this team's owners
      let teamOwners = league.teams
        .filter(t => t.id != team.id)
        .map(t => t.owners)
        .flat();
      let availablePlayers = league.players.filter(
        player => !teamOwners.find(owner => owner.id == player.user.id)
      );
      this.availableOwners = availablePlayers
        .map(player => player.user)
        .sort((a, b) => a.username.localeCompare(b.username));
      this.selectedOwners = team.owners.map(o => o.id);
    },
    deleteTeam: function() {
      let app = this;
      const csrftoken = getCookie("csrftoken");

      fetch(
        `${process.env.VUE_APP_PLATFORM}/api/leagues/${
          app.$route.params.leagueId
        }/teams/${app.team.id}/`,
        {
          credentials: "include",
          method: "DELETE",
          mode: "cors",
          headers: {
            "Content-Type": "application/x-www-form-urlencoded",
            "X-CSRFToken": csrftoken
          }
        }
      ).then(function(response) {
        if (response.status == 200 || response.status == 204) {
          app.$router.push(`/leagues/${app.league.id}/`);
          app.$store.commit("alert/addMessage", {
            message: `Removed team from league!`,
            class: "success",
            persist: false
          });
        } else {
          app.$store.commit("alert/addMessage", {
            message: `Unable to remove team from league.`,
            class: "danger",
            persist: false
          });
        }
      });
    },
    getLeague: function() {
      let app = this;
      //get league data, save accordingly
      fetch(
        `${process.env.VUE_APP_PLATFORM}/api/leagues/${
          app.$route.params.leagueId
        }`,
        {
          credentials: "include",
          mode: "cors"
        }
      )
        .then(function(response) {
          return response.json();
        })
        .then(function(response) {
          // app.$store.commit("breadcrumb/updateDynamicLinks",{ dynamic_links: [{ static_name: ':league', dynamic_name: response.name, url: `/leagues/${response.id}` }] });
          let team = response.teams.find(function(v, i, a) {
            return v.id == app.$route.params.teamId;
          });
          if (team) {
            app.team = team;
            app.name = team.name;
            app.getPotentialOwners(response, team);
            app.$store.commit("breadcrumb/updateDynamicLinks", {
              dynamic_links: [
                {
                  static_name: ":league",
                  dynamic_name: response.name,
                  url: `/leagues/${response.id}`
                },
                {
                  static_name: ":team",
                  dynamic_name: team.name,
                  url: `/leagues/${response.id}/teams/${team.id}`
                }
              ]
            });
            app.$store.commit("breadcrumb/display");
          } else {
            app.$store.commit("alert/addMessage", {
              message: "Unable to find team in this league.",
              class: "danger",
              persist: false
            });
          }
          app.league = response;
        });
    },
    saveTeam: function(e) {
      e.preventDefault();

      let app = this;
      const csrftoken = getCookie("csrftoken");
      let form = new URLSearchParams({
        name: app.name
      });

      for (let i = 0; i < app.selectedOwners.length; i++) {
        form.append("users", app.selectedOwners[i]);
      }

      fetch(
        `${process.env.VUE_APP_PLATFORM}/api/leagues/${
          app.$route.params.leagueId
        }/teams/${app.$route.params.teamId}/`,
        {
          credentials: "include",
          method: "PATCH",
          mode: "cors",
          body: form,
          headers: {
            "Content-Type": "application/x-www-form-urlencoded",
            "X-CSRFToken": csrftoken
          }
        }
      ).then(function(response) {
        if (response.status == 200) {
          app.$router.push(`/leagues/${app.league.id}/teams/${app.team.id}`);
          app.$store.commit("alert/addMessage", {
            message: "Team updated!",
            class: "success",
            persist: false
          });
        } else {
          app.$store.commit("alert/addMessage", {
            message: "Unable to update team.",
            class: "danger",
            persist: false
          });
        }
      });
    }
  }
};
</script>

<style lang="scss"></style>
